import { appURLS } from 'appRoot/app.constants';
import * as Fingerprint2 from 'fingerprintjs2';
import ObjectCopyService from "external-services/object-copy-service/index";
import AdminService from "external-services/diary-admin-service/admin.service";
import VenueActions, {VenueActionNames} from "app/actions/venue.actions";

const NS = 'TelemetryService'; // jshint ignore:line


interface IPerformance extends Performance {
  memory?: any,
}

class TelemetryService{
  private $http: any;
  private $rootScope: any;

  private fingerprint: string;
  /**
   * Horita:  `components` doesn't used in others, so removed.
   */
    // private components: any;

  private dataPoints: any[] = [];
  private saving: boolean = false;
  private batchAmount: number = 20;
  private maxInBatchAmount: number = 500;

  public telemetryEnabled: boolean = false;
  public telemetryLoggingEnabled: boolean = false;

  public setup($http: any, $rootScope: any): void {
    this.$http = $http;
    this.$rootScope = $rootScope;
  }

  public init(): void {
    if (Fingerprint2) {
      new Fingerprint2().get((fingerprint: string, components: any) => {
        this.fingerprint = fingerprint;
        // this.components = components;
        this.trackMemory();
      });
      this.$rootScope.$on('venue-loaded', () => this.checkSettings());
      // this.$rootScope.$on('venue-change', () => this.checkSettings());
      VenueActions.handleVenueAction(VenueActionNames.VENUE_CHANGE, () => this.checkSettings());
      this.checkSettings();
    }
  }

  /**
   * track a telemetry entry
   * @param name: The name of the event you wish to track follow lowerCamelCase convention
   * @param values: An and array of values arrays, [[name,value],[name,value],[name,value]]
   * @param customTags: An and array of custom tags to merge with the default tags, [[name,value],[name,value],[name,value]]
   **/

  public track(name: string, values: [string, any][], customTags: [string, any][] = null ): void {

    const account = AdminService.getAccount();
    const venue = AdminService.getVenue();

    // set tags
    const tags = ['fingerprint=' + this.fingerprint];

    if (venue) {
      tags.push('venueId=' + venue.id);
    }
    if (account) {
      tags.push('accountId=' + account.id);
    }
    if (customTags) {
      customTags.forEach((element: [string, any]) => {
        tags.push(element.join('='));
      });
    }

    // building body string
    const timestamp = new Date().getTime() * 1000000;
    let valuesStr = '';
    let body = name;

    if (tags.length) {
      body += ',' + tags.join(',');
    }
    if (values && values.length) {
      values.forEach((element: [string, any], index: number) => {
        if (index !== 0) valuesStr += ',';
        valuesStr += element[0] + '=' + element[1];
      });
      body += ' ' + valuesStr;
    }
    // add time stamp
    body += ' ' + timestamp;
    if (!this.dataPoints || this.dataPoints.length > this.maxInBatchAmount) {
      // dont let the data points get to big
      this.dataPoints = [];
    }

    this.dataPoints.push(body);
    if (this.telemetryLoggingEnabled) {
      console.info('Telemetry::', name, valuesStr);
    }
    if (this.telemetryEnabled && this.dataPoints.length > this.batchAmount && !this.saving) {
      this.bulkSave();
    }
  }

  /**
   * Track the memory of the device
   */
  public trackMemory(): void {
    const performanceTemp: IPerformance = performance;

    if (window.performance && performanceTemp.memory) {
      this.track('memory', [
        ['jsHeapSizeLimit', performanceTemp.memory.jsHeapSizeLimit],
        ['totalJSHeapSize', performanceTemp.memory.totalJSHeapSize],
        ['usedJSHeapSize', performanceTemp.memory.usedJSHeapSize]
      ], null);
      // check every 1 mins since the memory object is only updated every 20 https://bugs.webkit.org/attachment.cgi?id=154876&action=prettypatch
      setTimeout(() => {
        this.trackMemory();
      }, 1000 * 60 * 1);
    }
  }

  /****************************************** PRIVATE **********************************************/

  private checkSettings(): void {
    const venue = AdminService.getVenue();
    if (venue) {
      this.telemetryEnabled = venue.isTelemetryEnabled;
    }
  }

  private bulkSave(): void {
    this.saving = true;
    const dpToSave = ObjectCopyService.angularSafeCopy(this.dataPoints);
    this.dataPoints = [];
    const body = dpToSave.join('\n');

    //log

    console.log(appURLS.INFLUXDB + '/write?db=' + window.config.telemetry.db);
    console.log(window.config.telemetry.auth);
    console.log(body);

    //log

    this.$http.post(appURLS.INFLUXDB + '/write?db=' + window.config.telemetry.db, body, {
      headers: {
        'Authorization': window.config.telemetry.auth
      }
    }).then(function () {
      this.saving = false;
      if (this.service.telemetryLoggingEnabled) { }
    }).catch(function (err: any) {
      this.dataPoints.concat(dpToSave);
      this.saving = false;
      if (this.service.telemetryLoggingEnabled) {
        console.error(err);
      }
    });
  }
}

// creates a singleton instance to export
const instance = new TelemetryService();
export default instance as TelemetryService;
